import {
  Button,
  Checkbox,
  Col,
  Form,
  Input,
  Radio,
  Row,
  Select,
  Spin,
} from "antd";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../apis/store";
import { useEffect, useMemo, useState } from "react";
import {
  toAddVehicle,
  toGetBrands,
  toGetModel,
  toGetMyVehicle,
} from "../../apis/actions/vehicle.actions";
import { showNotitfication } from "../../utils/Utils";
import Navbar from "../../domains/Menu/Navbar";
import Footer from "../../domains/pages/Sections/Footer";
import { useNavigate } from "react-router-dom";
import { setVehicle } from "../../apis/slices/globalSlice";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { FaArrowLeft, FaArrowRight, FaCarAlt } from "react-icons/fa";
import { MdDirectionsCarFilled } from "react-icons/md";
import { BsCardText } from "react-icons/bs";
import { LuLayoutTemplate } from "react-icons/lu";
import {
  convertArabicToEnglish,
  convertEnglishToArabic,
  convertArabicToEnglishletters,
  convertEnglishToArabicLetters,
} from "../../utils/plateConversions";
import { highlightSearchMatch } from "../../utils/highlightSearchMatch";
import VehicleLicensePlate from "./VehicleLicensePlate";

const selectFilterByValue = (input: string, option: unknown) => {
  const o = option as { value?: string; data?: { value?: string } };
  const v = String(o?.value ?? o?.data?.value ?? "");
  const q = String(input).trim().toLowerCase();
  if (!q) return true;
  return v.toLowerCase().includes(q);
};

const PLATE_LETTER_OPTIONS_AR = [
  { value: "أ", label: "أ" },
  { value: "ب", label: "ب" },
  { value: "ح", label: "ح" },
  { value: "د", label: "د" },
  { value: "ر", label: "ر" },
  { value: "س", label: "س" },
  { value: "ص", label: "ص" },
  { value: "ط", label: "ط" },
  { value: "ع", label: "ع" },
  { value: "ق", label: "ق" },
  { value: "ك", label: "ك" },
  { value: "ل", label: "ل" },
  { value: "م", label: "م" },
  { value: "ن", label: "ن" },
  { value: "هـ", label: "هـ" },
  { value: "و", label: "و" },
  { value: "ى", label: "ى" },
];

const PLATE_LETTER_OPTIONS_EN = [
  { value: "A", label: "A" },
  { value: "B", label: "B" },
  { value: "J", label: "J" },
  { value: "D", label: "D" },
  { value: "R", label: "R" },
  { value: "S", label: "S" },
  { value: "X", label: "X" },
  { value: "T", label: "T" },
  { value: "E", label: "E" },
  { value: "G", label: "G" },
  { value: "K", label: "K" },
  { value: "L", label: "L" },
  { value: "Z", label: "Z" },
  { value: "N", label: "N" },
  { value: "H", label: "H" },
  { value: "U", label: "U" },
  { value: "V", label: "V" },
];

const AddVehicule = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { models } = useSelector((state: RootState) => state?.vehicle);
  const [form] = Form.useForm();
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [showExtraInputs, setShowExtraInputs] = useState<boolean>(false);
  const [letter1, setLetter1] = useState("");
  const [letter2, setLetter2] = useState("");
  const [letter3, setLetter3] = useState("");
  const [number, setNumber] = useState("");
  const [showInput, setShowInput] = useState(true);
  const { profil } = useSelector((state: RootState) => state?.login);
  const { loading } = useSelector(
    (state: RootState) => state.vehicle.addVehivcule
  );

  const [carModelSearch, setCarModelSearch] = useState("");

  const carModelOptions = useMemo(
    () =>
      (models?.list || []).map((option: any) => ({
        label: highlightSearchMatch(
          String(option.display_name ?? ""),
          carModelSearch
        ),
        value: option.display_name,
        id: option.id,
      })),
    [models?.list, carModelSearch]
  );

  const handleRadioChange = (e: any) => {
    setShowInput(e.target.value === "saudia");
  };

  useEffect(() => {
    dispatch(toGetModel());
  }, [dispatch]);
  const onFinish = async () => {
    try {
      await form.validateFields();
      const selected = models?.list.find(
        (el: any) => el.display_name == form.getFieldValue("car")
      );
      const success = (await dispatch(
        toAddVehicle({
          model_id: selected?.id ? selected.id : false,
          unverified_model_name: form.getFieldValue("unverified_model_name"),
          vin_sn: form.getFieldValue("vin"),
          plate_numbers: convertArabicToEnglish(
            form.getFieldValue("plate_numbers")
          ),
          plate_numbers_ar: showInput
            ? convertEnglishToArabic(form.getFieldValue("plate_numbers"))
            : "",
          plate_letters: showInput
            ? convertArabicToEnglishletters(letter3) +
              convertArabicToEnglishletters(letter2) +
              convertArabicToEnglishletters(letter1)
            : "",
          plate_letters_ar: showInput
            ? convertEnglishToArabicLetters(letter1) +
              " " +
              convertEnglishToArabicLetters(letter2) +
              " " +
              convertEnglishToArabicLetters(letter3)
            : "",

          // ponytail: description is optional in the form but required by the API — fall back to the model/plate.
          title:
            form.getFieldValue("title")?.trim() ||
            selected?.display_name ||
            form.getFieldValue("unverified_model_name") ||
            convertArabicToEnglish(form.getFieldValue("plate_numbers")),
        })
      )) as any;
      const add = success?.payload?.data?.result;

      if (add?.code === 200) {
        const clientName = profil?.data?.name;
        const messageEn = `Dear ${clientName}, thank you for adding your car. It is currently under review for approval.`;
        const messageAr = `عميلنا العزيز ${clientName} شكرا لاضافتك للسيارة وجاري العمل على اعتمادها`;

        if (showExtraInputs) {
          const message = i18n.language === "en" ? messageEn : messageAr;
          showNotitfication(message, "success", true);
        } else {
          showNotitfication("Car added successfully", "success");
        }

        toGetMyVehicle(i18n.language);
        dispatch(setVehicle({ id: add?.vehicle_id }));
        navigate("/services");
      } else {
        showNotitfication(add?.message, "error");
      }
    } catch (error) {}
  };

  return (
    <>
      <Navbar type="internal" />
      <main className="main ac-add-car-page">
        <div className="container pt-40 pb-170">
          <div className="row">
            <div className="col-12 ac-add-car__shell">
              <div className="ac-add-car__card">
                <div className="ac-add-car__hero">
                  <p className="ac-add-car__hero-badge ac--font-expo mb-0">
                    {t("profile.car.addmyCar")}
                  </p>
                  <h4 className="neutral-1000 ac--font-expo mt-3 mb-0">
                    {t("profile.car.info")}
                  </h4>
                </div>
                <div className="ac-add-car__body">
                  <Form form={form}>
                    <div className="ac-add-car__section">
                      <h3 className="ac-add-car__section-title">
                        {t("profile.car.addCarVehicleTitle")}
                      </h3>
                      <Form.Item
                        label=""
                        name="title"
                      >
                        <div className="form-group">
                          <Input.TextArea
                            className="ac--input-login ac-add-car__title-textarea"
                            placeholder={t("profile.car.title")}
                            maxLength={500}
                            showCount
                            autoSize={{ minRows: 4, maxRows: 12 }}
                          />
                        </div>
                      </Form.Item>
                      <Form.Item
                        label=""
                        name="car"
                        rules={[
                          {
                            required: !showExtraInputs,
                            message: t("profile.messages.6"),
                          },
                        ]}
                      >
                        <Select
                          placeholder={t("profile.car.model")}
                          virtual={false}
                          className="ac-add-car__select-model"
                          options={carModelOptions}
                          optionLabelProp="value"
                          showSearch
                          filterOption={selectFilterByValue}
                          onSearch={setCarModelSearch}
                          onSelect={() => setCarModelSearch("")}
                          disabled={showExtraInputs}
                          prefix={<FaCarAlt size={17} />}
                          size="large"
                          popupClassName="ac-add-car__select-model-dropdown"
                          getPopupContainer={(triggerNode) =>
                            triggerNode.parentNode
                          }
                        />
                      </Form.Item>
                      <Checkbox
                        className="ac-add-car__checkbox"
                        checked={showExtraInputs}
                        onChange={(e) => {
                          setShowExtraInputs(e.target.checked);
                        }}
                      >
                        <span
                          className={
                            i18n.language === "en"
                              ? "ac--font-jfbold"
                              : "ac--font-expo"
                          }
                        >
                          {t("profile.car.check")}
                        </span>
                      </Checkbox>

                      {showExtraInputs && (
                        <motion.div
                          initial={{ opacity: 0, y: -10 }}
                          animate={{ opacity: 1, y: 0 }}
                          exit={{ opacity: 0, y: -10 }}
                          transition={{ duration: 0.3 }}
                        >
                          <Form.Item
                            label=""
                            name="unverified_model_name"
                            rules={[
                              {
                                required: true,
                                message: t("profile.messages.6"),
                              },
                            ]}
                          >
                            <div className="form-group">
                              <Input
                                className="ac--input-login"
                                size="large"
                                type="text"
                                placeholder={t("profile.car.model")}
                                prefix={<MdDirectionsCarFilled size={17} />}
                              />
                            </div>
                          </Form.Item>
                        </motion.div>
                      )}

                      <Form.Item
                        label=""
                        name="vin"
                        rules={[
                          {
                            required: true,
                            message: t("profile.messages.6"),
                          },
                          {
                            len: 17,
                            message: "the Chassis number should be 17 char",
                          },
                        ]}
                      >
                        <div className="form-group">
                          <Input
                            className="ac--input-login"
                            size="large"
                            type="text"
                            placeholder={t("profile.car.vin")}
                            maxLength={17}
                            prefix={<BsCardText size={17} />}
                          />
                        </div>
                      </Form.Item>
                    </div>

                    <div className="ac-add-car__section ac-add-car__section--plate">
                      <h3 className="ac-add-car__section-title">
                        {t("profile.car.addCarPlateTitle")}
                      </h3>
                      <Row gutter={16} className="mt-0 mb-20">
                        <Col span={24}>
                          <Radio.Group
                            onChange={handleRadioChange}
                            defaultValue="saudia"
                            className="ac--radio-check"
                          >
                            <Radio
                              value="saudia"
                              className={
                                i18n.language === "en"
                                  ? "ac--font-jfbold"
                                  : "ac--font-expo"
                              }
                            >
                              {t("profile.car.saudi")}
                            </Radio>
                            <Radio
                              value="others"
                              className={
                                i18n.language === "en"
                                  ? "ac--font-jfbold"
                                  : "ac--font-expo"
                              }
                            >
                              {t("profile.car.others")}
                            </Radio>
                          </Radio.Group>
                        </Col>
                      </Row>
                      {showInput ? (
                        <>
                          <div className="ac-add-car__plate-row">
                            <div className="ac-add-car__plate-numbers-column">
                              <p className="ac-add-car__plate-field-caption ac--font-expo">
                                {t("profile.car.plate")}
                              </p>
                              <Form.Item
                                label=""
                                name="plate_numbers"
                                rules={[
                                  {
                                    required: true,
                                    message: t("profile.messages.6"),
                                  },
                                ]}
                              >
                                <div className="form-group">
                                  <Input
                                    className="ac--input-login"
                                    size="large"
                                    type="text"
                                    placeholder={t("profile.car.plate")}
                                    maxLength={4}
                                    prefix={<LuLayoutTemplate size={17} />}
                                    value={number}
                                    onChange={(value) =>
                                      setNumber(value.target.value)
                                    }
                                  />
                                </div>
                              </Form.Item>
                            </div>
                            <div className="ac-add-car__plate-letters-column">
                              <p className="ac-add-car__plate-field-caption ac--font-expo">
                                {t("profile.car.letter")}
                              </p>
                              <div
                                className="ac-add-car__plate-row__letters"
                                role="group"
                                aria-label={t("profile.car.letter")}
                              >
                                <Select
                                  className="ac-add-car__select-letter"
                                  size="large"
                                  popupClassName="ac-add-car__select-letter-dropdown"
                                  optionLabelProp="value"
                                  placeholder={t(
                                    "profile.car.plateLetterPlaceholder"
                                  )}
                                  title={t("profile.car.plateLetterSlotTitle", {
                                    n: 1,
                                  })}
                                  aria-label={t(
                                    "profile.car.plateLetterSlotTitle",
                                    { n: 1 }
                                  )}
                                  onChange={(value) => setLetter1(value)}
                                  value={letter1}
                                  options={
                                    i18n.language == "ar"
                                      ? PLATE_LETTER_OPTIONS_AR
                                      : PLATE_LETTER_OPTIONS_EN
                                  }
                                  allowClear
                                  getPopupContainer={(triggerNode) =>
                                    triggerNode.parentNode
                                  }
                                />
                                <Select
                                  className="ac-add-car__select-letter"
                                  size="large"
                                  popupClassName="ac-add-car__select-letter-dropdown"
                                  optionLabelProp="value"
                                  placeholder={t(
                                    "profile.car.plateLetterPlaceholder"
                                  )}
                                  title={t("profile.car.plateLetterSlotTitle", {
                                    n: 2,
                                  })}
                                  aria-label={t(
                                    "profile.car.plateLetterSlotTitle",
                                    { n: 2 }
                                  )}
                                  onChange={(value) => setLetter2(value)}
                                  value={letter2}
                                  options={
                                    i18n.language == "ar"
                                      ? PLATE_LETTER_OPTIONS_AR
                                      : PLATE_LETTER_OPTIONS_EN
                                  }
                                  allowClear
                                  getPopupContainer={(triggerNode) =>
                                    triggerNode.parentNode
                                  }
                                />
                                <Select
                                  className="ac-add-car__select-letter"
                                  size="large"
                                  popupClassName="ac-add-car__select-letter-dropdown"
                                  optionLabelProp="value"
                                  placeholder={t(
                                    "profile.car.plateLetterPlaceholder"
                                  )}
                                  title={t("profile.car.plateLetterSlotTitle", {
                                    n: 3,
                                  })}
                                  aria-label={t(
                                    "profile.car.plateLetterSlotTitle",
                                    { n: 3 }
                                  )}
                                  onChange={(value) => setLetter3(value)}
                                  value={letter3}
                                  options={
                                    i18n.language == "ar"
                                      ? PLATE_LETTER_OPTIONS_AR
                                      : PLATE_LETTER_OPTIONS_EN
                                  }
                                  allowClear
                                  getPopupContainer={(triggerNode) =>
                                    triggerNode.parentNode
                                  }
                                />
                              </div>
                            </div>
                          </div>
                          <div className="ac-add-car__plate-preview">
                            <div className="ac--plate-number-container">
                              <VehicleLicensePlate
                                plateNumbers={
                                  number || form.getFieldValue("plate_numbers")
                                }
                                letter1={letter1}
                                letter2={letter2}
                                letter3={letter3}
                                size="md"
                                ariaLabel={t("profile.car.plate")}
                              />
                            </div>
                          </div>
                        </>
                      ) : (
                        <>
                          <Row gutter={16}>
                            <Col span={24}>
                              <Form.Item
                                label=""
                                name="plate_numbers"
                                rules={[
                                  {
                                    required: true,
                                    message: t("profile.messages.6"),
                                  },
                                ]}
                              >
                                <div className="form-group">
                                  <Input
                                    className="ac--input-login"
                                    size="large"
                                    type="text"
                                    placeholder={t("profile.car.plate")}
                                    prefix={<LuLayoutTemplate size={17} />}
                                    value={number}
                                    onChange={(value) =>
                                      setNumber(value.target.value)
                                    }
                                  />
                                </div>
                              </Form.Item>
                            </Col>
                          </Row>
                        </>
                      )}
                    </div>
                    </Form>

                    <div className="form-group mb-0 ac-add-car__submit">
                      <Button
                        className="btn btn-primary w-100 ac--font-expo"
                        onClick={onFinish}
                        disabled={loading}
                      >
                        {loading ? (
                          <Spin size="small" className="me-2" />
                        ) : null}
                        {loading ? t("btn.loading") : t("profile.order.adds")}
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
      </main>
      <Footer type="external" />
    </>
  );
};
export default AddVehicule;
